module.exports = __webpack_public_path__ + "img/emails-table-alert.64e4e3c6.svg";